// src/screens/ValidationScreen.css.js
import { StyleSheet } from 'react-native';
import { AVAQualisTheme } from '../theme/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F5F5F5',
  },
  appbar: {
    backgroundColor: AVAQualisTheme.colors.primary,
    elevation: 4,
  },
  appbarTitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontSize: 20,
    fontWeight: 'bold',
  },
  appbarSubtitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontSize: 14,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: AVAQualisTheme.colors.primary,
  },
  searchContainer: {
    padding: 16,
    backgroundColor: '#FFFFFF',
    elevation: 2,
  },
  searchBar: {
    elevation: 0,
    backgroundColor: '#F5F5F5',
  },
  content: {
    flex: 1,
  },
  section: {
    marginBottom: 24,
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 2,
    borderBottomColor: '#E0E0E0',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333333',
  },
  sectionBadge: {
    backgroundColor: '#FF9800',
  },
  validatedBadge: {
    backgroundColor: '#4CAF50',
  },
  responseCard: {
    marginHorizontal: 16,
    marginVertical: 8,
    elevation: 2,
  },
  pendingCard: {
    borderLeftWidth: 4,
    borderLeftColor: '#FF9800',
  },
  validatedCard: {
    borderLeftWidth: 4,
    borderLeftColor: '#4CAF50',
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  titleSection: {
    flex: 1,
    marginRight: 12,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 2,
  },
  // Descrição logo abaixo do título
  formDescription: {
    fontSize: 12,
    color: '#666666',
    fontStyle: 'italic',
    marginBottom: 4,
    lineHeight: 16,
  },
  avaliadorText: {
    fontSize: 13,
    color: '#666666',
    marginTop: 2,
  },
  badge: {
    alignSelf: 'flex-start',
  },
  pendingBadge: {
    backgroundColor: '#FF9800',
  },
  formInfo: {
    marginVertical: 4,
  },
  
  // Linha de metadados compacta
  metaInfoRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.02)',
    padding: 4,
    borderRadius: 4,
    marginBottom: 6,
  },
  versionText: {
    fontSize: 10,
    color: AVAQualisTheme.colors.tertiary,
    fontWeight: '500',
  },
  separator: {
    fontSize: 10,
    color: AVAQualisTheme.colors.tertiary,
    marginHorizontal: 4,
  },
  complexityText: {
    fontSize: 10,
    fontWeight: '600',
  },
  
  // Container de processos inline
  processosInlineContainer: {
    marginVertical: 4,
  },
  processosLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#666666',
    marginBottom: 3,
  },
  processosChipsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
  processoChip: {
    height: 22,
    marginRight: 4,
    marginBottom: 2,
  },
  
  // Informações da avaliação inline
  evaluationInfoInline: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    backgroundColor: '#F5F5F5',
    padding: 6,
    borderRadius: 4,
    marginVertical: 4,
    gap: 8,
  },
  evaluationTextInline: {
    fontSize: 10,
    color: '#555555',
    fontWeight: '500',
  },
  
  // Container de emails inline
  emailsInlineContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#E8F5E9',
    padding: 5,
    borderRadius: 4,
    marginVertical: 3,
  },
  emailsLabel: {
    fontSize: 10,
    color: '#2E7D32',
    fontWeight: '600',
    marginRight: 6,
  },
  emailsList: {
    fontSize: 10,
    color: '#2E7D32',
    flex: 1,
  },
  
  // Container de unidades inline
  unidadesContainer: {
    marginTop: 6,
  },
  unidadesTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
    marginBottom: 4,
  },
  unidadesInlineGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
  unidadeInlineCard: {
    backgroundColor: `${AVAQualisTheme.colors.info}08`,
    borderRadius: 4,
    borderLeftWidth: 2,
    borderLeftColor: AVAQualisTheme.colors.info,
    padding: 5,
    flexBasis: 'calc(50% - 2px)',
    minWidth: 160,
  },
  unidadeInlineCode: {
    fontSize: 9,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
  },
  unidadeInlineName: {
    fontSize: 9,
    fontWeight: '500',
    color: '#333333',
    lineHeight: 12,
  },
  unidadeInlineInfo: {
    fontSize: 8,
    color: '#666666',
    marginTop: 2,
  },
  
  chip: {
    height: 22,
    marginRight: 3,
    marginBottom: 2,
  },
  chipText: {
    fontSize: 9,
  },
  dateSection: {
    marginTop: 6,
    paddingTop: 6,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  dateText: {
    fontSize: 11,
    color: '#666666',
    marginBottom: 2,
  },
  validationText: {
    fontSize: 11,
    color: '#4CAF50',
    fontWeight: '600',
    marginTop: 2,
  },
  revalidationText: {
    fontSize: 11,
    color: '#2196F3',
    fontStyle: 'italic',
    marginTop: 2,
  },
  waitingText: {
    fontSize: 11,
    color: '#FF9800',
    fontWeight: '600',
    marginTop: 3,
  },
  viewButton: {
    marginRight: 8,
  },
  validateButton: {
    marginLeft: 'auto',
  },
  revalidateButton: {
    marginLeft: 'auto',
  },
  emptyCard: {
    margin: 16,
  },
  emptyContent: {
    alignItems: 'center',
    padding: 32,
  },
  emptyTitle: {
    marginTop: 16,
    color: '#666666',
  },
  emptyText: {
    textAlign: 'center',
    color: '#999999',
  },
  bottomSpacer: {
    height: 80,
  },
  alertText: {
    fontSize: 12,
    fontWeight: '600',
  },
  validatedSection: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  validationBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#E8F5E9',
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 20,
    marginRight: 8,
  },
  validationBadgeIcon: {
    fontSize: 18,
    marginRight: 6,
  },
  validationBadgeText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#2E7D32',
  },
  validationBadgeDate: {
    fontSize: 9,
    color: '#2E7D32',
  },
  validateButtonDisabled: {
    backgroundColor: '#E0E0E0',
    borderWidth: 2,
    borderColor: '#FFC107',
    borderStyle: 'dashed',
  },
  validationAlert: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFF8E1',
    padding: 8,
    borderRadius: 4,
    marginTop: 4,
  },
  validationAlertText: {
    fontSize: 11,
    color: '#FF6F00',
    marginLeft: 6,
    flex: 1,
  },

  // Estilos para instruções de validação
  instructionCard: {
    margin: 16,
    marginBottom: 8,
    backgroundColor: '#E3F2FD',
    borderLeftWidth: 4,
    borderLeftColor: '#2196F3',
  },
  instructionCardValidated: {
    backgroundColor: '#F5F5F5',
    borderLeftColor: '#9E9E9E',
  },
  instructionContent: {
    padding: 16,
  },
  instructionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1976D2',
    marginBottom: 8,
  },
  instructionTitleValidated: {
    color: '#616161',
    fontSize: 14,
  },
  instructionText: {
    fontSize: 14,
    color: '#333333',
    lineHeight: 20,
  },
  instructionTextValidated: {
    fontSize: 12,
    color: '#757575',
    fontStyle: 'italic',
  },
  instructionIcon: {
    marginRight: 8,
  },
});